export default {
    contactPageTitle: "Contactez-nous",
    contactPageDescription: "Une question ou un commentaire ? Envoyez-nous un message et nous vous répondrons dans les plus brefs délais.",
    contactInfoLabel: "Informations de contact",
    contactInfoEmailLabel: "E-mail",
    contactInfoResponseTimeLabel: "Délai de réponse",
    contactInfoResponseTimeValue: "Sous 24 à 48 heures",
    contactFormTitle: "Envoyer un message",
    contactFormNameLabel: "Nom",
    contactFormNamePlaceholder: "Votre nom",
    contactFormEmailLabel: "E-mail",
    contactFormEmailPlaceholder: "votre@email.com",
    contactFormSubjectLabel: "Sujet",
    contactFormSubjectPlaceholder: "Quel est l'objet de votre message ?",
    contactFormMessageLabel: "Message",
    contactFormMessagePlaceholder: "Votre message...",
    contactFormSubmitActionLabel: "Envoyer le message",
}
